import { SortMenuItem } from '@/types';

export interface Sorting {
    sort: SortMenuItem[];
}
